import {css} from '@emotion/css';
import {FontLineHeight, FontSize, FontWeight, TextAlignment} from '@fo/shared/styles/variables/fonts';

const styles = {
  paragraph: (
    alignment: TextAlignment = TextAlignment.LEFT,
    fontSize: FontSize = FontSize.L,
    fontWeight: FontWeight = FontWeight.REGULAR,
    italic = false
  ): string => css`
    label: paragraph;
    margin-top: 0;
    color: currentColor;
    line-height: ${FontLineHeight.BASE};
    text-align: ${alignment};
    margin-bottom: ${fontSize};
    font-size: ${fontSize};
    font-weight: ${fontWeight};
    ${italic &&
    css`
      font-style: italic;
    `};

    b {
      font-weight: ${FontWeight.SEMI_BOLD};
    }
  `,
};

export default styles;
